"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _HoverAccentButton = _interopRequireDefault(require("./HoverAccentButton"));

var _AccentButton = _interopRequireDefault(require("./AccentButton"));

var s = _interopRequireWildcard(require("./DropdownButton.style"));

function renderButton(button) {
  var buttonType = 'Accent';
  var buttonProps = {};

  if (typeof button === 'string') {
    buttonProps = {
      text: button
    };
  } else {
    buttonType = button.type;
    buttonProps = button.props || {};
  }

  var ButtonComponent = buttonType === 'Accent' ? _AccentButton.default : _HoverAccentButton.default;
  return _react.default.createElement(ButtonComponent, buttonProps);
}

function renderOverlay(buttons) {
  return _react.default.createElement("div", {
    className: s.dropdownContainer
  }, buttons.map(function (b, i) {
    return (// eslint-disable-next-line react/no-array-index-key
      _react.default.createElement("div", {
        className: s.buttonContainer,
        key: i
      }, renderButton(b))
    );
  }));
}

function DropdownButton(_ref) {
  var button = _ref.button,
      dropdown = _ref.dropdown,
      dropdownButtons = _ref.dropdownButtons;
  var _dropdown$placement = dropdown.placement,
      placement = _dropdown$placement === void 0 ? 'bottomRight' : _dropdown$placement,
      _dropdown$popupWidth = dropdown.popupWidth,
      popupWidth = _dropdown$popupWidth === void 0 ? 150 : _dropdown$popupWidth,
      otherProps = (0, _objectWithoutProperties2.default)(dropdown, ["placement", "popupWidth"]);
  return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({
    overlay: renderOverlay(dropdownButtons),
    placement: placement,
    popupWidth: popupWidth
  }, otherProps), renderButton(button));
}

DropdownButton.defaultProps = {
  dropdown: {
    overlay: _react.default.createElement("div", null)
  },
  dropdownButtons: []
};

var ButtonProps = _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.shape({
  type: _propTypes.PropTypes.oneOf(['Accent', 'HoverAccent']).isRequired,
  props: _propTypes.PropTypes.shape(_HoverAccentButton.default.propTypes)
}), _propTypes.PropTypes.string]);

DropdownButton.propTypes = {
  button: ButtonProps.isRequired,
  dropdown: _propTypes.PropTypes.shape((0, _objectSpread2.default)({}, _Dropdown.default.propTypes, {
    overlay: undefined
  })),
  dropdownButtons: _propTypes.PropTypes.arrayOf(ButtonProps)
};
var _default = DropdownButton;
exports.default = _default;